import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "color_box" }
const _hoisted_2 = { class: "search_" }
const _hoisted_3 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_pop = _resolveComponent("pop")!
  const _component_search = _resolveComponent("search")!

  return (_openBlock(), _createElementBlock("div", {
    class: "App",
    ref: _ctx.getApp
  }, [
    _createVNode(_component_pop, {
      msg: _ctx.state.popMsg
    }, null, 8, ["msg"]),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_search, {
          onEmitColor: _ctx.getColor,
          onRandomAllColors: _ctx.randomAllColors,
          searchText: _ctx.state.searchText
        }, null, 8, ["onEmitColor", "onRandomAllColors", "searchText"])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.colorArr, (color, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "block",
          style: _normalizeStyle('background:#' + color),
          key: index,
          onClick: ($event: any) => (_ctx.targetBlock(index, color))
        }, [
          _createElementVNode("section", {
            class: "compare",
            style: _normalizeStyle('background:' + _ctx.state.compareColor)
          }, null, 4)
        ], 12, _hoisted_3))
      }), 128))
    ])
  ], 512))
}